import { render, staticRenderFns } from "./AccountSections.vue?vue&type=template&id=4c967480&scoped=true&"
import script from "./AccountSections.vue?vue&type=script&lang=js&"
export * from "./AccountSections.vue?vue&type=script&lang=js&"
import style0 from "./AccountSections.vue?vue&type=style&index=0&id=4c967480&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c967480",
  null
  
)

export default component.exports